// extracted by mini-css-extract-plugin
module.exports = {"price_selected":"price_selected-1kYEu","fare_family":"fare_family-1qP-L","prices__wrp":"prices__wrp-3Wjx8","price":"price-37z-y","price__money":"price__money-bRhYz"};